var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", [
        _c("div", [
          _c("article", { staticClass: "box" }, [
            _c("div", { staticClass: "columns" }, [
              _vm._m(0),
              _c("div", { staticClass: "column is-narrow" }, [
                _vm.value.orm
                  ? _c(
                      "div",
                      { staticClass: "dropdown is-right is-hoverable" },
                      [
                        _vm._m(1),
                        _c(
                          "div",
                          {
                            staticClass: "dropdown-menu",
                            attrs: { id: "dropdown-menu-pnet", role: "menu" },
                          },
                          [
                            _c("div", { staticClass: "dropdown-content" }, [
                              _vm.isActionEnabled &&
                              _vm.ormUnreadMessageCount == 0 &&
                              _vm.value.orm.canSubmit
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "dropdown-item dropdown-item-has-icon",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.sendQuote(
                                            _vm.ormSendQuoteTypes.Quote
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._m(2),
                                      _c(
                                        "span",
                                        { staticClass: "dropdown-item-text" },
                                        [_vm._v("Submit Quote")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.isSubmitTaxInvoiceEnabled
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "dropdown-item dropdown-item-has-icon",
                                      class: {
                                        "is-disabled":
                                          _vm.cannotRaiseInvoice ||
                                          _vm.hasDiffInvoicedAndAuthorised,
                                      },
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          !_vm.cannotRaiseInvoice &&
                                            !_vm.hasDiffInvoicedAndAuthorised &&
                                            _vm.sendInvoice(false)
                                        },
                                      },
                                    },
                                    [
                                      _vm._m(3),
                                      _c(
                                        "span",
                                        { staticClass: "dropdown-item-text" },
                                        [_vm._v("Submit Tax Invoice")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.isActionEnabled
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "dropdown-item dropdown-item-has-icon",
                                      attrs: { href: "#" },
                                      on: { click: _vm.declineQuoteRequest },
                                    },
                                    [
                                      _vm._m(4),
                                      _c(
                                        "span",
                                        { staticClass: "dropdown-item-text" },
                                        [_vm._v("Decline Quote Request")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.isActionEnabled
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "dropdown-item dropdown-item-has-icon",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.sendQuote(
                                            _vm.ormSendQuoteTypes.TotalLoss
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._m(5),
                                      _c(
                                        "span",
                                        { staticClass: "dropdown-item-text" },
                                        [_vm._v("Inform Total Loss")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.isActionEnabled
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "dropdown-item dropdown-item-has-icon",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.sendQuote(
                                            _vm.ormSendQuoteTypes
                                              .RequestInspection
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._m(6),
                                      _c(
                                        "span",
                                        { staticClass: "dropdown-item-text" },
                                        [_vm._v("Request Inspection")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.isSubmitTaxInvoiceEnabled
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "dropdown-item dropdown-item-has-icon",
                                      class: {
                                        "is-disabled": !_vm.cannotRaiseInvoice,
                                      },
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          !_vm.cannotRaiseInvoice &&
                                            _vm.sendInvoice(true)
                                        },
                                      },
                                    },
                                    [
                                      _vm._m(7),
                                      _c(
                                        "span",
                                        { staticClass: "dropdown-item-text" },
                                        [_vm._v("Re-activate Tax Invoice")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c("hr", { staticClass: "dropdown-divider" }),
                              _vm.$user.info.isSupportUser
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "dropdown-item dropdown-item-has-icon",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showUtilities()
                                        },
                                      },
                                    },
                                    [
                                      _vm._m(8),
                                      _c(
                                        "span",
                                        { staticClass: "dropdown-item-text" },
                                        [_vm._v("Utilities")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "dropdown-item dropdown-item-has-icon",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.viewMessages("ORM")
                                    },
                                  },
                                },
                                [
                                  _vm._m(9),
                                  _c(
                                    "span",
                                    { staticClass: "dropdown-item-text" },
                                    [_vm._v("View Messages")]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
            _c("div", { staticClass: "columns" }, [
              _c("div", { staticClass: "column is-narrow" }, [
                _c("table", { staticClass: "table is-bordered is-striped" }, [
                  _c("tr", [
                    _c(
                      "td",
                      {
                        staticClass: "has-text-weight-bold has-vertical-middle",
                      },
                      [_vm._v("Unread Messages")]
                    ),
                    _c("td", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "is-flex is-align-items-center is-justify-content-space-between",
                        },
                        [
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.ormUnreadMessageCount) +
                                " Unread "
                            ),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "button is-primary",
                              on: { click: _vm.handleViewOrmUnreadMessages },
                            },
                            [_vm._v(" View ")]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _c("tr", [
                    _c(
                      "td",
                      {
                        staticClass: "has-text-weight-bold has-vertical-middle",
                      },
                      [_vm._v("Message No.")]
                    ),
                    _vm.$user.info.isSupportUser
                      ? _c(
                          "td",
                          [
                            _c("the-mask", {
                              staticClass: "input",
                              attrs: {
                                placeholder: "Message No.",
                                mask: ["##"],
                              },
                              model: {
                                value: _vm.innerValue.orm.messageNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.innerValue.orm, "messageNo", $$v)
                                },
                                expression: "innerValue.orm.messageNo",
                              },
                            }),
                          ],
                          1
                        )
                      : _c("td", [_vm._v(_vm._s(_vm.value.orm.messageNo))]),
                  ]),
                  _c("tr", [
                    _c(
                      "td",
                      {
                        staticClass: "has-text-weight-bold has-vertical-middle",
                      },
                      [_vm._v("ReInstatement No.")]
                    ),
                    _vm.$user.info.isSupportUser
                      ? _c(
                          "td",
                          [
                            _c("the-mask", {
                              staticClass: "input",
                              attrs: {
                                type: "number",
                                placeholder: "ReInstatement No.",
                                mask: ["##"],
                              },
                              model: {
                                value: _vm.innerValue.orm.reinstatementNo,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.innerValue.orm,
                                    "reinstatementNo",
                                    $$v
                                  )
                                },
                                expression: "innerValue.orm.reinstatementNo",
                              },
                            }),
                          ],
                          1
                        )
                      : _c("td", [
                          _vm._v(_vm._s(_vm.value.orm.reinstatementNo)),
                        ]),
                  ]),
                  _c("tr", [
                    _c(
                      "td",
                      {
                        staticClass: "has-text-weight-bold has-vertical-middle",
                      },
                      [_vm._v("Quote Status")]
                    ),
                    _vm.$user.info.isSupportUser
                      ? _c("td", [
                          _c("div", { staticClass: "select" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.innerValue.orm.quoteStatusId,
                                    expression: "innerValue.orm.quoteStatusId",
                                  },
                                ],
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.innerValue.orm,
                                      "quoteStatusId",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              _vm._l(_vm.quoteStatusTypes, function (type) {
                                return _c(
                                  "option",
                                  {
                                    key: type.value,
                                    domProps: { value: type.value },
                                  },
                                  [_vm._v(_vm._s(type.name))]
                                )
                              }),
                              0
                            ),
                          ]),
                        ])
                      : _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.quoteStatusTypes?.find(
                                (s) => s.value === _vm.value.orm.quoteStatusId
                              )?.name
                            )
                          ),
                        ]),
                  ]),
                  _c("tr", [
                    _c("td", { staticClass: "has-text-weight-bold" }, [
                      _vm._v("Vehicle ID"),
                    ]),
                    _vm.$user.info.isSupportUser
                      ? _c("td", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.innerValue.orm.vehicleId,
                                expression: "innerValue.orm.vehicleId",
                              },
                            ],
                            staticClass: "input is-capitalized",
                            attrs: {
                              type: "text",
                              placeholder: "Vehicle ID",
                              maxlength: "20",
                            },
                            domProps: { value: _vm.innerValue.orm.vehicleId },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.innerValue.orm,
                                  "vehicleId",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ])
                      : _c("td", [_vm._v(_vm._s(_vm.value.orm.vehicleId))]),
                  ]),
                  _c("tr", [
                    _c("td", { staticClass: "has-text-weight-bold" }, [
                      _vm._v("Underwriter"),
                    ]),
                    _vm.$user.info.isSupportUser
                      ? _c("td", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.innerValue.orm.underwriter,
                                expression: "innerValue.orm.underwriter",
                              },
                            ],
                            staticClass: "input is-capitalized",
                            attrs: {
                              type: "text",
                              placeholder: "Underwriter",
                              maxlength: "45",
                            },
                            domProps: { value: _vm.innerValue.orm.underwriter },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.innerValue.orm,
                                  "underwriter",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ])
                      : _c("td", [_vm._v(_vm._s(_vm.value.orm.underwriter))]),
                  ]),
                  _c("tr", [
                    _c("td", { staticClass: "has-text-weight-bold" }, [
                      _vm._v("Make & Model"),
                    ]),
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm.value.orm.make) +
                          " " +
                          _vm._s(_vm.value.orm.model) +
                          " " +
                          _vm._s(_vm.value.orm.series)
                      ),
                    ]),
                  ]),
                  _c("tr", [
                    _c("td", { staticClass: "has-text-weight-bold" }, [
                      _vm._v("Quote Type"),
                    ]),
                    _c("td", [_vm._v(_vm._s(_vm.value.orm.quoteType))]),
                  ]),
                  _c("tr", [
                    _c("td", { staticClass: "has-text-weight-bold" }, [
                      _vm._v("Damaged Areas"),
                    ]),
                    _c("td", [_vm._v(_vm._s(_vm.value.orm.damagedAreas))]),
                  ]),
                  _c("tr", [
                    _c("td", { staticClass: "has-text-weight-bold" }, [
                      _vm._v("QDE Status"),
                    ]),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatQdeStatus(_vm.value.orm.qdeStatus)
                        )
                      ),
                    ]),
                  ]),
                  _c("tr", [
                    _c(
                      "td",
                      {
                        staticClass: "has-text-weight-bold has-vertical-middle",
                      },
                      [_vm._v("Batch Number")]
                    ),
                    _vm.ormQuoteBatch
                      ? _c("td", [
                          _c(
                            "div",
                            {
                              staticClass:
                                "is-flex is-align-items-center is-justify-content-space-between",
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.ormQuoteBatch.batchNo)),
                              ]),
                              _c(
                                "button",
                                {
                                  staticClass: "button is-primary",
                                  on: { click: _vm.viewOrmBatchDetail },
                                },
                                [_vm._v(" View ")]
                              ),
                            ]
                          ),
                        ])
                      : _c("td", [_vm._v("N/A")]),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "column is-5" }, [
                _vm.ormUnreadMessageCount > 0 ||
                !_vm.value.orm.canSubmit ||
                _vm.IsOrmPaymentUnableLoad
                  ? _c("div", { staticClass: "unread-messages-section mb-4" }, [
                      _c("div", { staticClass: "is-flex flex-start" }, [
                        _c(
                          "span",
                          {
                            staticClass:
                              "material-symbols-outlined has-text-warning mr-2",
                          },
                          [_vm._v(" warning ")]
                        ),
                        _c("div", [
                          _vm.IsOrmPaymentUnableLoad
                            ? _c("p", { staticClass: "mb-3" }, [
                                _vm._v(
                                  " Note: The latest Payment Authorisation message for this quote was "
                                ),
                                _c("b", [_vm._v("NOT")]),
                                _vm._v(
                                  " loaded successfully because the message number is out of sequence. The expected message number is "
                                ),
                                _c("b", [
                                  _vm._v(_vm._s(_vm.ormExpectedMessageNo)),
                                ]),
                                _vm._v(", but the received message is "),
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.ormLatestPaymentAuthorisedMessage
                                        .ormMessageNo
                                    )
                                  ),
                                ]),
                                _vm._v(". Please load the message manually. "),
                              ])
                            : _vm._e(),
                          !_vm.value.orm.canSubmit
                            ? _c("p", { staticClass: "mb-3" }, [
                                _vm._v(
                                  " Note: The Submit Quote button is currently disabled because a Payment Authorisation Message has been received for this job. "
                                ),
                              ])
                            : _vm._e(),
                          _vm.ormUnreadMessageCount > 0
                            ? _c("p", { staticClass: "mb-3" }, [
                                _vm._v(
                                  " Note: The submit Quote button is currently disabled because there are unread messages for this quote. Please view and load messages to unlock the submit function. "
                                ),
                              ])
                            : _vm._e(),
                          !_vm.value.orm.canSubmit
                            ? _c("div", [_vm._m(10), _vm._m(11), _vm._m(12)])
                            : _vm._e(),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm.hasDiffInvoicedAndAuthorised
                  ? _c(
                      "article",
                      {
                        staticClass: "message",
                        class:
                          "is-warning " +
                          (_vm.$theme.isDark ? "is-dark" : "is-light"),
                      },
                      [
                        _vm._m(13),
                        _c(
                          "section",
                          {
                            staticClass: "message-body",
                            class: _vm.$theme.isDark ? "is-dark" : "is-light",
                          },
                          [
                            _vm._m(14),
                            _c("div", { staticClass: "table-container mb-4" }, [
                              _c(
                                "table",
                                { staticClass: "table is-fullwidth" },
                                [
                                  _vm._m(15),
                                  _c(
                                    "tbody",
                                    [
                                      _vm._l(_vm.invoiceRows, function (row) {
                                        return _c("tr", { key: row.quoteId }, [
                                          _c("td", [_vm._v(_vm._s(row.label))]),
                                          _c(
                                            "td",
                                            { staticClass: "has-text-right" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$filters.formatCurrency(
                                                    row.total,
                                                    _vm.$userInfo.locale,
                                                    false,
                                                    2
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ])
                                      }),
                                      _c(
                                        "tr",
                                        {
                                          staticClass:
                                            "has-text-weight-bold tr-top-border-2px",
                                        },
                                        [
                                          _c("td", [_vm._v("Totals")]),
                                          _c(
                                            "td",
                                            { staticClass: "has-text-right" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$filters.formatCurrency(
                                                    _vm.totalQuotesAmount,
                                                    _vm.$userInfo.locale,
                                                    false,
                                                    2
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "tr",
                                        {
                                          staticClass:
                                            "has-text-weight-semibold tr-top-border-2px authorised-row",
                                        },
                                        [
                                          _c("td", {}, [
                                            _vm._v("Authorised Amount in ORM"),
                                          ]),
                                          _c(
                                            "td",
                                            { staticClass: "has-text-right" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$filters.formatCurrency(
                                                    _vm.totalAuthorisedAmount,
                                                    _vm.$userInfo.locale,
                                                    false,
                                                    2
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "tr",
                                        {
                                          staticClass:
                                            "has-text-weight-semibold",
                                        },
                                        [
                                          _c("td", [
                                            _vm._v(
                                              "Amount (Ext GST) In Invoice"
                                            ),
                                          ]),
                                          _c(
                                            "td",
                                            { staticClass: "has-text-right" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$filters.formatCurrency(
                                                    _vm.totalInvoicedAmount,
                                                    _vm.$userInfo.locale,
                                                    false,
                                                    2
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "tr",
                                        {
                                          staticClass:
                                            "has-text-weight-bold difference-row",
                                        },
                                        [
                                          _c("td", [_vm._v("Difference")]),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "has-text-right has-text-danger has-text-weight-bold",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$filters.formatCurrency(
                                                    _vm.amountDifference,
                                                    _vm.$userInfo.locale,
                                                    false,
                                                    2
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm.cannotRaiseInvoice
                  ? _c("div", [
                      _c("div", { staticClass: "bulma-message-modal" }, [
                        _c(
                          "article",
                          {
                            staticClass: "message bulma-message-modal-panel",
                            class:
                              "is-warning " +
                              (_vm.$theme.isDark ? "is-dark" : "is-light"),
                          },
                          [
                            _vm._m(16),
                            _c(
                              "section",
                              {
                                staticClass: "message-body",
                                class: _vm.$theme.isDark
                                  ? "is-dark"
                                  : "is-light",
                              },
                              [_vm._m(17)]
                            ),
                          ]
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
          _c(
            "article",
            { staticClass: "box" },
            [
              _c("p", { staticClass: "title" }, [_vm._v("Remarks")]),
              _c(
                "bulma-table",
                {
                  staticClass:
                    "table is-bordered is-striped is-narrow is-fullwidth",
                  attrs: {
                    columns: _vm.columns,
                    "page-index": _vm.filter.pageIndex,
                    "page-size": _vm.filter.pageSize,
                    "total-rows": _vm.remarkTotalRows,
                    "is-loading": _vm.isTableLoading,
                    "sort-column": _vm.filter.sortColumn,
                    "sort-order": _vm.filter.sortOrder,
                    "show-header": false,
                  },
                  on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                },
                [
                  _vm._l(_vm.pagedRemarks, function (remark, index) {
                    return _c(
                      "tr",
                      {
                        key: remark.remarkId,
                        on: {
                          click: function ($event) {
                            return _vm.highlightSelected(index, $event)
                          },
                        },
                      },
                      [
                        _c("td", { staticClass: "is-content-width" }, [
                          _c("span", { staticClass: "tag is-info" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatDateTimeLocale(
                                  remark.remarkDateTime,
                                  _vm.$userInfo.locale
                                )
                              )
                            ),
                          ]),
                        ]),
                        _c("td", { staticClass: "is-remark" }, [
                          _c("div", [_vm._v(_vm._s(remark.remarks))]),
                        ]),
                      ]
                    )
                  }),
                  _c("template", { slot: "empty" }, [
                    _c("section", { staticClass: "section" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "content has-text-grey has-text-centered",
                        },
                        [
                          _c("span", { attrs: { icon: "icon is-large" } }, [
                            _c("i", {
                              staticClass: "mdi mdi-48px mdi-emoticon-sad",
                            }),
                          ]),
                          _c("p", [_vm._v("Nothing")]),
                        ]
                      ),
                    ]),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm.isXmlViewerModalActive
        ? _c(
            "xml-viewer-modal",
            {
              attrs: {
                active: _vm.isXmlViewerModalActive,
                "quote-id": _vm.value.quoteId,
                "message-type": _vm.messageType,
                "page-size": 10,
              },
              on: {
                "update:active": function ($event) {
                  _vm.isXmlViewerModalActive = $event
                },
                close: function ($event) {
                  _vm.isXmlViewerModalActive = false
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("View " + _vm._s(_vm.messageType) + " Messages"),
              ]),
            ]
          )
        : _vm._e(),
      _vm.isOrmDeclineQuoteRequestModalActive
        ? _c("orm-decline-quote-request-modal", {
            attrs: {
              active: _vm.isOrmDeclineQuoteRequestModalActive,
              value: _vm.value,
            },
            on: {
              "update:active": function ($event) {
                _vm.isOrmDeclineQuoteRequestModalActive = $event
              },
              close: function ($event) {
                _vm.isOrmDeclineQuoteRequestModalActive = false
              },
            },
          })
        : _vm._e(),
      _vm.isOrmSendQuoteModalActive
        ? _c("orm-send-quote-modal", {
            attrs: {
              active: _vm.isOrmSendQuoteModalActive,
              value: _vm.value,
              "send-quote-type": _vm.sendQuoteType,
            },
            on: {
              "update:active": function ($event) {
                _vm.isOrmSendQuoteModalActive = $event
              },
              close: function ($event) {
                _vm.isOrmSendQuoteModalActive = false
              },
            },
          })
        : _vm._e(),
      _vm.isOrmSubmitTaxInvoiceModalActive
        ? _c("orm-submit-tax-invoice-modal", {
            attrs: {
              active: _vm.isOrmSubmitTaxInvoiceModalActive,
              "is-reactivate-invoice": _vm.isReactivateInvoice,
              value: _vm.value,
            },
            on: {
              "update:active": function ($event) {
                _vm.isOrmSubmitTaxInvoiceModalActive = $event
              },
              sent: function ($event) {
                return _vm.reload()
              },
            },
          })
        : _vm._e(),
      _vm.isConfirmModalActive
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isConfirmModalActive,
                "ok-text": "Proceed",
                "cancel-text": "Cancel",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isConfirmModalActive = $event
                },
                ok: function ($event) {
                  return _vm.sendQuote(_vm.ormSendQuoteTypes.Quote, true)
                },
                cancel: function ($event) {
                  _vm.isConfirmModalActive = false
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Submit Quote"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _c("span", { staticClass: "has-text-weight-bold" }, [
                    _vm._v(
                      " AUTHORISATION FOR LAST QUOTE NOT YET RECEIVED FROM INSURER. WE STRONGLY RECCOMMEND THAT YOU WAIT FOR THE AUTHORISATION MESSAGE AND LOAD IT INTO THIS QUOTE BEFORE YOU SEND MORE VARIATIONS "
                    ),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm.isWarningModalActive
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isWarningModalActive,
                "ok-text": "Yes",
                "cancel-text": "No",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isWarningModalActive = $event
                },
                ok: function ($event) {
                  return _vm.showSubmitTaxInvoiceModal(true)
                },
                cancel: function ($event) {
                  _vm.isWarningModalActive = false
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Send Invoice"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _c(
                    "span",
                    { staticClass: "has-text-primary has-text-weight-bold" },
                    [
                      _vm._v(
                        " Some items haven't been authorised. Do you want to proceed? Please note, only the authorised amounts will be sent to the insurer. "
                      ),
                    ]
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm.isOrmUtilitiesModalActive
        ? _c("orm-pnet-utilities-modal", {
            attrs: { active: _vm.isOrmUtilitiesModalActive },
            on: {
              "update:active": function ($event) {
                _vm.isOrmUtilitiesModalActive = $event
              },
            },
            model: {
              value: _vm.innerValue,
              callback: function ($$v) {
                _vm.innerValue = $$v
              },
              expression: "innerValue",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title" }, [_vm._v("ORM")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dropdown-trigger" }, [
      _c(
        "button",
        {
          staticClass: "button",
          attrs: {
            "aria-haspopup": "true",
            "aria-controls": "dropdown-menu-pnet",
          },
        },
        [
          _c("span", [_vm._v("ORM")]),
          _c("span", { staticClass: "icon is-small" }, [
            _c("i", {
              staticClass: "mdi mdi-chevron-down",
              attrs: { "aria-hidden": "true" },
            }),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "icon is-small is-left has-text-primary" },
      [_c("i", { staticClass: "mdi mdi-upload mdi-18px" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "icon is-small is-left has-text-primary" },
      [_c("i", { staticClass: "mdi mdi-currency-usd mdi-18px" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "icon is-small is-left has-text-primary" },
      [_c("i", { staticClass: "mdi mdi-cancel mdi-18px" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "icon is-small is-left has-text-primary" },
      [_c("i", { staticClass: "mdi mdi-car-off mdi-18px" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "icon is-small is-left has-text-primary" },
      [_c("i", { staticClass: "mdi mdi-eye-check-outline mdi-18px" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "icon is-small is-left has-text-primary" },
      [_c("i", { staticClass: "mdi mdi-restart mdi-18px" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      {
        staticClass: "icon is-small is-left has-text-primary",
        staticStyle: { "self-align": "center" },
      },
      [_c("i", { staticClass: "mdi mdi-tools mdi-18px" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      {
        staticClass: "icon is-small is-left has-text-primary",
        staticStyle: { "self-align": "center" },
      },
      [_c("i", { staticClass: "mdi mdi-file-code mdi-18px" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "mb-3" }, [
      _vm._v(
        " Please review the information below and send an email to the appropriate department via the "
      ),
      _c("strong", [_vm._v("Communications")]),
      _vm._v(" tab. "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "mb-3" }, [
      _c("strong", [_vm._v("Quote Variation")]),
      _c("br"),
      _vm._v(
        " If submitting a quote variation, email nationalassessing@iag.com.au "
      ),
      _c(
        "a",
        {
          staticClass: "icon has-text-primary",
          attrs: { href: "mailto:nationalassessing@iag.com.au" },
        },
        [_c("i", { staticClass: "mdi mdi-link-box-variant mdi-24px" })]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "mb-3" }, [
      _c("strong", [_vm._v("Invoice Variation")]),
      _c("br"),
      _vm._v(
        " If submitting an invoice variation, email supplierinvoices@iag.com.au "
      ),
      _c(
        "a",
        {
          staticClass: "icon has-text-primary",
          attrs: { href: "mailto:supplierinvoices@iag.com.au" },
        },
        [_c("i", { staticClass: "mdi mdi-link-box-variant mdi-24px" })]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "message-header" }, [
      _c("span", { staticClass: "is-flex is-align-items-center" }, [
        _c("span", { staticClass: "msr msr-24px mr-2 has-text-amber" }, [
          _vm._v("warning"),
        ]),
        _c("span", [_vm._v("Authorised Amount Mismatch")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "mb-3" }, [
      _vm._v(
        " The authorised amount for this invoice doesn't match the invoiced amount."
      ),
      _c("br"),
      _vm._v(" To continue, "),
      _c("span", [
        _vm._v(
          "please update the invoice so that the totals align before proceeding."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Quote")]),
        _c("th", { staticClass: "has-text-right" }, [_vm._v("Amount")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "message-header" }, [
      _c("span", { staticClass: "is-flex is-align-items-center" }, [
        _c("span", { staticClass: "msr msr-24px mr-2 has-text-amber" }, [
          _vm._v("warning"),
        ]),
        _c("span", [_vm._v("Invoice Pending Payment Authority")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "mb-3" }, [
      _vm._v(
        " An invoice has already been submitted for this quote and is awaiting payment authority."
      ),
      _c("br"),
      _vm._v(" Raising a new invoice is currently disabled. "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }